// errors
export const amountOutOfRange = new RangeError('Amount out of range');
export const missingBoundaries = new ReferenceError('Missing range boundaries');
